import classNames from "classnames";
import { verisModule } from "clients/verisModule";
import { EtherscanIcon } from "components/icons";
import TokenIcon from "components/icons/TokenIcon";
import { BasicProps } from "components/types/BasicProps";
import { ITransfer } from "logic/types/transfers/ITransfer";
import Link from "next/link";
import { FC } from "react";

type Props = BasicProps & {
  transfer: ITransfer;
};

export const TransferRow: FC<Props> = (props) => {
  const { transfer, className } = props;

  return (
    <tr className={classNames(className)}>
      <td className="pr-[15px] pt-[15px] max-w-[178px] w-[178px] text-ellipsis overflow-hidden whitespace-nowrap">
        {transfer.txHash}
      </td>
      <td className="px-[15px] pt-[15px]">{transfer.method}</td>
      <td className="px-[15px] pt-[15px]">{transfer.dateFormated}</td>
      <td className="px-[15px] pt-[15px] max-w-[178px] w-[178px] text-ellipsis overflow-hidden whitespace-nowrap">
        {transfer.from}
      </td>
      <td className="px-[15px] pt-[15px] max-w-[178px] w-[178px] text-ellipsis overflow-hidden whitespace-nowrap">
        {transfer.to}
      </td>
      <td className="px-[15px] pt-[15px] max-w-[120px] w-[129px]">
        <div className="flex items-center gap-1">
          {transfer.valueFormated}
          <TokenIcon
            className="w-[15px] h-[15px]"
            currency={transfer.currency}
          />
        </div>
      </td>
      <td className="pt-[15px] pl-[15px]">
        <Link
          className="cursor-pointer"
          target="_blank"
          href={`https://${verisModule.chainName.toLowerCase()}.etherscan.io/tx/${
            transfer.txHash
          }`}
          onClick={(e) => e.stopPropagation()}
        >
          <EtherscanIcon className="w-[15px] h-[15px]" />
        </Link>
      </td>
    </tr>
  );
};
